/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useEffect, useState } from 'react';
import { useAppState } from '@revenuewell/logic-app-state';
import { useConfig } from '@revenuewell/logic-config';
import { useNavigation } from '@revenuewell/logic-navigation';
import { useOidc } from '@revenuewell/logic-oidc';
import { ProductMenuLoader } from '@revenuewell/logic-product-menu-loader';

/* eslint-disable-next-line */
export interface IProductMenuProps {
  visible: boolean;
  focused?: boolean;
  onReady?(): void;
}

export function ProductMenu(props: IProductMenuProps) {
  const { setError } = useAppState();
  const { config } = useConfig();
  const { getAccessToken, getClaims, logoutRedirect } = useOidc();
  const { getLocationIdUrlParam, getCustomerIdUrlParam } = useNavigation();

  const [accessToken, setAccessToken] = useState<string | undefined>();
  const [accessTokenLocationId, setAccessTokenLocationId] = useState<number>();
  const [accessTokenUserName, setAccessTokenUserName] = useState<string>();
  const [masterAccountId, setMasterAccountId] = useState<number | undefined>(undefined);

  useEffect(() => {
    Promise.all([getAccessToken(), getClaims()])
      .then(([accessToken, claims]) => {
        setAccessToken(accessToken ?? undefined);
        setAccessTokenLocationId(claims.locationId);
        setAccessTokenUserName(`${claims?.firstName} ${claims?.lastName}`);
        setMasterAccountId(claims.masterAccountId);
      })
      .catch((error) => {
        console.error(error);
        setError({ message: 'Unable to initialize Product Menu.' });
      });
  }, []);

  return (
    <>
      {accessToken &&
        (accessTokenLocationId || getLocationIdUrlParam()) &&
        accessTokenUserName && (
          <ProductMenuLoader
            apiUrl={config.productMenu.apiUrl}
            accessToken={accessToken}
            locationId={getLocationIdUrlParam() || accessTokenLocationId || 0}
            customerId={getCustomerIdUrlParam() || masterAccountId || 0}
            userName={accessTokenUserName}
            onError={(error) => setError(error)}
            onReady={() => {
              return props.onReady ? props.onReady() : null;
            }}
            onLogout={() => logoutRedirect()}
            selectedItem={config.productMenu.selectedItem}
            visible={props.visible}
            focused={props.focused}
          />
        )}
    </>
  );
}
